<template>
  <a-row class="life_costs-pages-pay-unpaid content-container" id="life_costs-pages-pay-unpaid">
    <a-row class="container-scroll">
      <form name="loginform" id="formExport" action method="post" target="_blank">
        <input type="hidden" id="mchGroupCode" name="mchGroupCode" />
        <input type="hidden" id="mchSiteNo" name="mchSiteNo" />
        <input type="hidden" id="mchOrderNo" name="mchOrderNo" />
        <input type="hidden" id="mchOrderDttm" name="mchOrderDttm" />
        <input type="hidden" id="goodsTitle" name="goodsTitle" />
        <input type="hidden" id="goodsDetail" name="goodsDetail" />
        <input type="hidden" id="orderAmount" name="orderAmount" />
        <input type="hidden" id="chnlMchCode" name="chnlMchCode" />
        <input type="hidden" id="chnlMchName" name="chnlMchName" />
        <input type="hidden" id="mchCustId" name="mchCustId" />
        <input type="hidden" id="mchCustName" name="mchCustName" />
        <input type="hidden" id="mchCustIp" name="mchCustIp" />
        <input type="hidden" id="mchCustMac" name="mchCustMac" />
      </form>
      <!--导航部分-->
      <section class="layout-pad-full layout-margin-bottom back-white">
        <a-breadcrumb>
          <a-breadcrumb-item>首页</a-breadcrumb-item>
          <a-breadcrumb-item>生活中心</a-breadcrumb-item>
          <a-breadcrumb-item>
            <a href="javascript:;" @click.stop="previousPageEvt">账单管理</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item>未缴费账单</a-breadcrumb-item>
        </a-breadcrumb>
      </section>
      <!--导航部分 end-->
      <!--表格部分-->
      <section class="layout-table layout-pad-full layout-margin-bottom back-white">
        <a-table 
          :row-selection="{selectedRowKeys: tableObj.selectedRowKeys, onChange: selectRowChange}" 
          :scroll="scroll"
          class="J_compensation_list_table" 
          :columns="tableObj.columns" 
          :data-source="tableObj.list" 
          :pagination="false"
          :loading="tableObj.tableLoading" 
          >
        </a-table>
      </section>
      <!--表格部分 end-->
      <!-- 按钮 -->
      <section class="table-option" v-if="tableObj.list.length>0">
        <a-row class="table-option_row">
          <a-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24" class="table-option_alert">
            <a-icon class="icon" type="info-circle" />
            <span class="text">{{selectmsg}}</span>
          </a-col>
          <a-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24" class="table-option_extend">
            <div class="description">
              <p class="total">费用合计：<span class="info f18">{{payAmount}}</span>元</p>
              <p class="total">本次缴费：<span class="default f18">{{condition.payAmount}}</span>元</p>
            </div>
            <div class="btn-group">
              <a-button type="primary" icon="pay-circle" class="space-margin-left"
                :disabled="tableObj.selectedRowKeys.length<=0" @click.stop="submitEvt">去缴费</a-button>
            </div>
          </a-col>
        </a-row>
      </section>
      <!-- 按钮 end -->

      <a-modal 
        center
        class="unpaidView" 
        :title="paytext" 
        v-model="countdown"
        :closable="false"
        :mask-closable="false"
        :keyboard="false">
        <div style="text-align: center;">
          <a-progress type="circle" :percent="percent" :format="percent => `${percent}`" />
        </div>
        <template slot="footer">
          <a-button type="primary" :disabled="percent < 100" @click="countdownhandleOk">确认</a-button>
        </template>
      </a-modal>
    </a-row>
  </a-row>
</template>

<script>
import ajax from '../../lib/axios/ajax'
import { POST_PAYBILL_ARREARSLIST, POST_PAYBILL_PAYCONFIRM, POST_PAYBILL_GETPAYPAPER } from '../../lib/axios/apilist'
import commonUtil from '../../lib/plugins/commonUtil'

export default {
  data () {
    // 请求地址
    let ajaxParam = {
      POST_PAYBILL_ARREARSLIST: POST_PAYBILL_ARREARSLIST,
      POST_PAYBILL_PAYCONFIRM: POST_PAYBILL_PAYCONFIRM,
      POST_PAYBILL_GETPAYPAPER: POST_PAYBILL_GETPAYPAPER,
    };
    //分页信息
    let pagination = {
      pageSize: 10,
      current: 1,
      defaultCurrent: 1,
      defaultPageSize: 10,
      total: 0,
      showQuickJumper: true,
      showTotal: total => `共${total}条数据`,
      showSizeChanger: true,
      pageSizeOptions: ['10', '30', '50', '100'],
      showSizeChange: (current, pageSize) => {
        this.pagination.pageSize = pageSize;
        this.pagination.current = current;
        this.$options.methods.search.bind(this)();
      },
      change: (page, pageSize) => {
        this.pagination.current = page;
        this.pagination.pageSize = pageSize;
        this.$options.methods.search.bind(this)(false);
      }
    };
    let pageData = {};
    let condition = {
      custId: undefined, // 客户ID
      communityId: undefined, // 项目ID
      communityCode: undefined, // 门店号
      communityName: undefined,
      houseId: undefined, // 真实项目ID
      billAmount: undefined, // 账单总金额，
      payAmount: undefined, // 付款总金额，和账单总金额一致
      disAmount: 0, // 优惠总金额，传0
      acctItemIds: undefined, // 账单ID，来自第二个接口返回值，用'-'拼接，如：157276-164315-164316-164317
      list: undefined,
      payTypeNo: '85', // 支付方式，是对公还是对私，之后会提供码值
    }
    let tableObj = {
      tableLoading: false,
      selectedRowKeys: [],
      list: [],
      columns: [
        // {
        //   title: '项目ID',
        //   dataIndex: 'communityId',
        // }, {
        //   title: '费用科目名称',
        //   dataIndex: 'feeItemTypeName',
        // }, {
        //   title: '帐期',
        //   dataIndex: 'billingCycle',
        // },
        // {
        //   title: '用量',
        //   dataIndex: 'amount',
        // }, {
        //   title: '单价',
        //   dataIndex: 'unitPrice',
        // }, {
        //   title: '应缴本金',
        //   dataIndex: 'fee',
        // }, {
        //   title: '税率',
        //   dataIndex: 'taxRate',
        // }, {
        //   title: '税额',
        //   dataIndex: 'taxFee',
        // }, {
        //   title: '违约金',
        //   dataIndex: 'lfree',
        // }, {
        //   title: '应交金额',
        //   dataIndex: 'payFee',
        // }

        {
          title: '项目ID',
          dataIndex: 'communityId',
        },
        {
          title: '费用科目名称',
          dataIndex: 'feeItemTypeName',
        },
        {
          title: '帐期（应收）',
          dataIndex: 'billingCycle',
        },
        {
          title: '应交金额',
          dataIndex: 'fee',
        },
        {
          title: '违约金',
          dataIndex: 'lfree',
        },
        {
          title: '应交金额总额',
          dataIndex: 'payFee',
        }
      ]
    }
    let scroll = {
      x: 1000,
      // y: 500,
    }

    return {
      payAmount: 0,
      pagination,
      pageData,
      condition,
      tableObj,
      ajaxParam,
      scroll,
      payFeeTotal: 0,
      countdown: false,
      percent: 0,
      paytext: "支付中..."
    }
  },
  mounted() {
    //进入页面
    //cabinVue 里面所有的this 都指向当前这个vue 实例
    //vue 更多使用方法请查看vue官方文档
    this.$nextTick(function () {
      //nextTick 用于当data数据改变,触发vue 渲染,且渲染完毕使用

    });
    this.condition.custId = this.$route.query.custId
    this.condition.communityId = this.$route.query.communityId
    this.condition.communityCode = this.$route.query.communityCode
    this.condition.communityName = decodeURI(this.$route.query.communityName)
    this.initFunc()
  },
  //如果 不需要保存页面状态必须添加下面这个方法
  beforeDestroy: function () {
    
  },
  destroyed: function () {
    //离开页面方法
  },
  //监听属性变化，，变量必须是data里声明的
  watch: {},
  //监听属性变化，配置变量的同时也起到data声明的作用
  computed: {
    selectmsg() {
      return `已选择 ${this.tableObj.selectedRowKeys.length} 项`
    },
  },
  methods: {
    previousPageEvt() {
      this.$router.go(-1)
    },
    resize() {
      this.scroll.y = window.innerHeight - 60 - 50 - 42 - 110
    },
    selectRowChange(selectedRowKeys) {
      this.tableObj.selectedRowKeys = selectedRowKeys
      let payFeeTotal = 0
      let acctItemIds = [];
      let listItem = [];
      this.payAmount = 0
      this.tableObj.list.forEach((item, index) => {
        this.payAmount = commonUtil.Add(this.payAmount, item.payFee)
        let some = this.tableObj.selectedRowKeys.some(el => {
          return el === index
        })
        if (some) {
          payFeeTotal = commonUtil.Add(item.payFee, payFeeTotal)
          
          acctItemIds.push(item.acctItemStr)
          listItem.push({
            billAmt: item.payFee,
            billId: item.acctItemStr,
            billName: item.feeItemTypeName,
          })
          item.acctItemStr
        }
      })
      this.condition.acctItemIds = acctItemIds.join('-')
      this.condition.payAmount = payFeeTotal
      this.condition.billAmount = payFeeTotal
      this.condition.list = listItem;
    },
    // 初始化数据
    initFunc() {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_ARREARSLIST;
      const _this = this
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.tableObj.list = res.data.dataList
          //调整TABLE样式
          _this.$nextTick(function () {
            //根据表格实际宽度设置scrollX
            _this.scroll.x = 100 * _this.tableObj.columns.length;
          });
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        ...this.condition
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    // table查询搜索
    search(startFlag = true, param = {}, tempPagination = this.pagination) {
      let searchParam = {
        ...this.condition
      }

      //开启加载效果
      this.tableObj.tableLoading = true;

      //浅复制
      let requestParam = Object.assign({}, searchParam, param);

      let currentPageNo = tempPagination.current;
      let currentPageSize = tempPagination.pageSize;
      if (startFlag) {
        requestParam.currentPage = 1;
      } else {
        requestParam.currentPage = currentPageNo;
      }
      requestParam.pageSize = currentPageSize;

      // 清空table数据
      this.tableObj.list.splice(0, this.tableObj.list.length);

      let that = this;
      let successFunc = (res) => {
        // 关闭加载效果
        this.tableObj.tableLoading = false;

        if (res.code === "0000") {
          this.pagination.current = res.data.currentPage;
          this.pagination.defaultCurrent = res.data.currentPage;
          this.pagination.pageSize = res.data.pageSize;
          this.pagination.total = res.data.totalCount;
          this.tableObj.list = res.data.list

          //调整TABLE样式
          that.$nextTick(function () {
            //根据表格实际宽度设置scrollX
            that.scrollX = 100 * that.tableObj.columns.length;
          });
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.tableObj.tableLoading = false;
        this.$error({
          title: '提示',
          content: res.result,
        });
      };

      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_ARREARSLIST;
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    },
    submitEvt() {
      this.$confirm({
        title: '提示',
        content: '确认提交吗？',
        onOk: () => {
          this.payConfirm()
        },
      });
    },
    payConfirm() {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_PAYCONFIRM;
      let successFunc = (res) => {
        debugger
        if (res.code === "0000") {
          this.getPayPaper(res.data)
          this.countdown = true;
          this.countdownStartEvt();
        } else if (res.code === "1017") {
          let payOrderNo = res.data.map((item) => {
            return item.payOrderNo
          });
          window.localStorage.setItem("payOrderNo", JSON.stringify(payOrderNo));
          let parmas = {
            payOrderNo: JSON.stringify(payOrderNo)
          }
          this.$success({
            title: "提示",
            content: `${res.result}`,
            onOk: () => {
              this.$router.push({
                path: '/pay/payList',
                query:parmas
              })
            },
          });
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        ...this.condition
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    // 进度开始方法
    countdownStartEvt() {
      this.paytext = "支付中...";
      let _this = this;
      var percentsetInterval = setInterval(() => {
        if (_this.percent < 100) {
          _this.percent += 10;
        } else {
          clearInterval(percentsetInterval)
          _this.countdownEndEvt()
        }
      }, 1000);
    },
    // 倒计时完成方法
    countdownEndEvt() {
      this.paytext = "支付完成！";
    },
    countdownhandleOk() {
      this.countdown = false;
      this.paytext = "支付中...";
      this.percent = 0;
      window.location.reload()
    },
    // 获取支付页面
    getPayPaper(params) {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_GETPAYPAPER;
      const formdom = document.getElementById("formExport");
      formdom.action = url;
      document.getElementById("mchGroupCode").value = params.mchGroupCode;
      document.getElementById("mchSiteNo").value = params.mchSiteNo;
      document.getElementById("mchOrderNo").value = params.mchOrderNo;
      document.getElementById("mchOrderDttm").value = params.mchOrderDttm;
      document.getElementById("goodsTitle").value = params.goodsTitle;
      document.getElementById("goodsDetail").value = params.goodsDetail;
      document.getElementById("orderAmount").value = params.orderAmount;
      document.getElementById("chnlMchCode").value = params.chnlMchCode;
      document.getElementById("chnlMchName").value = params.chnlMchName;
      document.getElementById("mchCustId").value = params.mchCustId;
      document.getElementById("mchCustName").value = params.mchCustName;
      document.getElementById("mchCustIp").value = params.mchCustIp;
      document.getElementById("mchCustMac").value = params.mchCustMac;
      document.loginform.submit();
    }
  }
}
</script>

<style scoped>
.container-scroll {
    position: relative;
}

.life_costs-pages-pay-unpaid .table-option {
    height: 60px;
    border: 1px solid #c0c6d8;
    background: #f0f5ff;
    box-sizing: border-box;
    padding: 10px;
}
.description{
  margin-right: 15px;
}
.description p{
  margin-bottom: 0;
}
.life_costs-pages-pay-unpaid .table-option_row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
        align-items: center;
}

.life_costs-pages-pay-unpaid .table-option_extend {
    float: right;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-pack: end;
        justify-content: flex-end;
    -ms-flex-align: center;
        align-items: center;
}

.life_costs-pages-pay-unpaid .table-option_extend .total {
    line-height: 1;
}

.life_costs-pages-pay-unpaid .f18 {
    font-size: 18px;
    font-weight: bold;
}

.life_costs-pages-pay-unpaid .info {
    color: #1890FF;
}

.life_costs-pages-pay-unpaid .default {
    color: #000000;
}

.life_costs-pages-pay-unpaid .table-option_alert .icon {
    color: #1890FF;
    font-size: 14px;
}

.life_costs-pages-pay-unpaid .table-option_alert .text {
    color: #000000;
    padding-left: 10px;
}

.life_costs-pages-pay-unpaid .unpaidView .ant-modal-content .ant-modal-body {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
        flex-direction: column;
    -ms-flex-pack: center;
        justify-content: center;
    -ms-flex-align: center;
        align-items: center;
}
</style>